import React, { createContext, useMemo, useRef } from 'react';
import { ROUTE_REDESIGN } from 'js/constants/pathnames';
import { ROUTE_DISCOVER } from 'new/constants/pathnames';
import { ScreenComponent } from 'new/routes/RouterManager';
import styles from './Discover.module.scss';
import { Redirect, Route, Switch } from 'react-router-dom';
import { router } from 'new/routes/router';
import PrivateRoute from 'js/components/route_utils/PrivateRoute';
import { Nexsets } from 'new/components/discover/Nexsets';
import { useSectionNavigation, useLastVisitedPath } from 'new/hooks/useSectionNavigation';

export const DiscoverContext = createContext({
  containerRef: { current: null },
});

export const Discover: ScreenComponent<any> = () => {
  const containerRef = useRef();
  useSectionNavigation('discover');

  const contextValue = useMemo(() => {
    return { containerRef };
  }, []);

  const defaultPath = Nexsets.screenConfig.path as string;
  const lastVisitedPath = useLastVisitedPath('discover', ROUTE_DISCOVER, defaultPath);

  return (
    <div className={styles.container} ref={containerRef}>
      <DiscoverContext.Provider value={contextValue}>
        <Switch>
          {router.manager.getRoutes('discover').map((route) => (
            <PrivateRoute key={route.name} {...route} />
          ))}
          <Route path="*">
            {lastVisitedPath ? <Redirect to={lastVisitedPath} /> : <Redirect to={defaultPath} />}
          </Route>
        </Switch>
      </DiscoverContext.Provider>
    </div>
  );
};

Discover.screenConfig = {
  path: `${ROUTE_REDESIGN}/discover`,
  domain: 'main',
  screenName: 'Discover',
  header: {
    title: 'Discover',
  },
};
